/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketplace_Seo_Galicia_Faq_A3Inputs */

const es_marketplace_seo_galicia_faq_a3 = /** @type {(inputs: Marketplace_Seo_Galicia_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Depende de la embarcación. Barcos de hasta 15 CV no requieren titulación; para el resto necesitas carnet válido o contratar patrón. Muchas experiencias (mejillones, Sálvora, Cíes) ya lo incluyen.`)
};

const gl_marketplace_seo_galicia_faq_a3 = /** @type {(inputs: Marketplace_Seo_Galicia_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Depende da embarcación. Barcos de ata 15 CV non requiren titulación; para o resto necesitas carnet válido ou contratar patrón. Moitas experiencias (mexillóns, Sálvora, Cíes) xa o inclúen.`)
};

const en_marketplace_seo_galicia_faq_a3 = /** @type {(inputs: Marketplace_Seo_Galicia_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It depends on the boat. Craft up to 15 HP need no licence; otherwise you need a valid certificate or hire a skipper. Many experiences (mussels, Sálvora, Cíes) include one.`)
};

/**
* | output |
* | --- |
* | "It depends on the boat. Craft up to 15 HP need no licence; otherwise you need a valid certificate or hire a skipper. Many experiences (mussels, Sálvora, Cíes..." |
*
* @param {Marketplace_Seo_Galicia_Faq_A3Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const marketplace_seo_galicia_faq_a3 = /** @type {((inputs?: Marketplace_Seo_Galicia_Faq_A3Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketplace_Seo_Galicia_Faq_A3Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_marketplace_seo_galicia_faq_a3(inputs)
	if (locale === "en") return en_marketplace_seo_galicia_faq_a3(inputs)
	return es_marketplace_seo_galicia_faq_a3(inputs)
});